const pressListInit = () => {
    const mainPattern = document.querySelectorAll('.gg-press-list');

    mainPattern.forEach((module) => {
        module.querySelectorAll('article a').forEach(a => {
            const externalLink = a.querySelector('.gravity-block-dynamic-boxes__presses-external-link');
            if (externalLink && /^(https?:\/\/[^\s$.?#].[^\s]*)$/i.test(externalLink.textContent.trim())) {
                a.target = '_blank';
                a.href = externalLink.textContent.trim();
            }
        });
    });
};
pressListInit();
const observeChanges = () => {
    const targetNode = document.querySelector('.gg-press-list');
    const config = { childList: true, subtree: true };
    
    const callback = function(mutationsList) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                pressListInit();
            }
        }
    };
    const observer = new MutationObserver(callback);
    if (targetNode) {
        observer.observe(targetNode, config);
    }
};
observeChanges();
